/* eslint-disable no-unused-vars */

import React from 'react'
import styles from './styles.module.scss'
import { ReactComponent as ClockIcon } from '../../../../assets/icons/clock-icon.svg'
import { useDispatch } from 'react-redux'
import { togglePopup } from '../../../../Redux/popups/popupSlice'

const index = ({ card, t }) => {
  t = t || ((i) => i)
  const dispatch = useDispatch()
  const handleEditApt = () => {
    dispatch(
      togglePopup({
        pointer: 3,
        data: { apt: card, editing: true }
      })
    )
  }
  
  // Function to capitalize first letter of each word
  const capitalizeWords = (text) => {
    if (!text) return text
    return text.split(' ').map(word => 
      word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    ).join(' ')
  }
  
  // Get service name from multiple possible fields
  const getServiceName = (card) => {
    if (card?.services && Array.isArray(card.services) && card.services.length > 0) {
      return card.services.join(', ')
    }
    if (card?.name) {
      return card.name
    }
    if (card?.operation_name) {
      return card.operation_name
    }
    return t('no_operation')
  }
  
  const { title, description, fromStr, toStr, patient_name, category, color } = card || {}
  const serviceName = getServiceName(card)
  
  return (
    <div className={styles.appointment_container_card} onClick={handleEditApt}>
      <div className={styles.patient_section}>
        <p className={styles.pt_name}>{capitalizeWords(patient_name) || t('no_pt_linked')}</p>
        <span className={styles.pt_indicative}>{capitalizeWords(description) || t('no_description')}</span>
      </div>
      <div className={styles.appointment_section}>
        <div className={styles.timing_and_op}>
          <div className={styles.timing}>
            <ClockIcon className={styles.clock_icon} />
            <span className={styles.time}>{fromStr || t('no_time')}</span>
          </div>
          <div className={styles.op_info_data}>
            <span
              className={styles.op_icon}
              style={{
                backgroundColor: color || 'black'
              }}
            />
            <span className={styles.op}>{capitalizeWords(serviceName)}</span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default index
